export default __webpack_public_path__ + "static/media/frame7.16a61c52.webp";